import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';

export const Layout = styled(AntLayout)`
  .ant-layout-content {
    background: var(--white-100);
  }
`;
export const CenterAlignedBox = styled.div<{ gap?: number }>`
  display: flex;
  align-items: center;
  gap: ${({ gap = 8 }) => `${gap}px`};
`;
